var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ion-page"},[_c('ion-content',{staticClass:"ion-padding",attrs:{"fullscreen":""}},[_c('items')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }